/**
 * The HTML for a loading spinner.
 * The spinner consists of three bouncing dots and includes ARIA attributes for accessibility.
 */
export const loadingIcon = `
    <div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait">
        <div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div>
    </div>
`;